var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_59---Money-Bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "#E8EAF0",
    d: "M53.6,81.3c-6.1,3.1-12.8,4.6-19.6,4.4c-6.8,0.2-13.6-1.3-19.6-4.4V161 c1.8-0.2,3.6-0.3,5.4-0.3c6.8-0.2,13.6,1.3,19.6,4.4v-25.8c0-5.7,5.7-10.4,14.3-12.7V81.3H53.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E8EAF0",
    cx: 19.6,
    cy: 175,
    rx: 19.6,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    fill: "#E8EAF0",
    d: "M0,184.9v8c0,2.9,7.8,7.1,19.6,7.1c11.8,0,19.6-4.3,19.6-7.1v-8c-6.1,3.1-12.8,4.6-19.6,4.4 C12.8,189.5,6.1,188,0,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    fill: "#E8EAF0",
    d: "M105.4,32.6c2.6,2,5.9,3.1,9.2,3.1c-3.1-5.3-5.5-11-7.3-16.9c-0.5-1.9,0.6-3.9,2.5-4.4 c1.9-0.5,3.9,0.6,4.4,2.5c2,6.7,5,13.1,9,18.8h3.7c4-5.8,7-12.1,9-18.8c0.5-1.9,2.5-3,4.4-2.5c1.9,0.5,3,2.5,2.5,4.4 c-1.8,5.9-4.2,11.6-7.3,16.9c3.2,0,6.4-1.1,9-3.1c8.4-6.5,11.3-16.9,12.3-24.5c0.2-1.3-0.4-2.6-1.5-3.3c-1.2-0.8-2.8-0.8-4.1,0 c-2.5,1.6-5.4,2.4-8.4,2.3c-4.1,0-8.1-1.5-11.1-4.4C129.8,1,127.4,0,124.9,0s-4.9,1-6.7,2.8c-3,2.8-7,4.4-11.1,4.4 c-2.9,0.1-5.8-0.7-8.3-2.3c-0.6-0.4-1.3-0.6-2-0.6c-0.7,0-1.4,0.2-2.1,0.6c-1.1,0.7-1.7,2-1.5,3.3C94.2,15.7,97.1,26.1,105.4,32.6 L105.4,32.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_1_",
    fill: "#E8EAF0",
    cx: 55.4,
    cy: 21.4,
    rx: 19.6,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2_",
    fill: "#E8EAF0",
    cx: 33.9,
    cy: 71.4,
    rx: 19.6,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    fill: "#E8EAF0",
    d: "M197.2,115.1c-11.6-49.3-42.6-69.5-52.1-74.6c-1.7,0.8-3.6,1.5-5.5,1.8l6.6,6.2 c0.7,0.6,1.1,1.5,1.1,2.5c0,0.9-0.3,1.9-1,2.6c-0.6,0.7-1.5,1.1-2.5,1.1c-0.9,0-1.9-0.3-2.6-1l-11.7-10.9h-1.1v10.7 c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6V42.9h-1.1l-11.7,10.9c-0.7,0.6-1.6,1-2.6,1c-0.9,0-1.8-0.4-2.5-1.1c-0.6-0.7-1-1.6-1-2.6 c0-0.9,0.4-1.8,1.1-2.5l6.6-6.2c-1.9-0.4-3.8-1-5.5-1.8C96,45.5,88,52,81.1,59.5L81,59.6c-2.6,2.8-5.1,5.8-7.4,8.9 c-1.2,1.5-3.4,1.9-4.9,0.7c-1.6-1.1-1.9-3.3-0.8-4.9c2.3-3.2,4.7-6,7-8.7V31.3c-6.1,3.1-12.8,4.6-19.6,4.4 c-6.8,0.2-13.6-1.3-19.6-4.4v25.9c14.4,0.5,25,6.4,25,14.2v53.8c1.8-0.2,3.6-0.3,5.4-0.3c15.3,0,26.8,6.1,26.8,14.3v39.3h65 c3.7,0,22.9-0.7,34-14.6C200.4,153,202.3,136.6,197.2,115.1L197.2,115.1z M142.9,114.3c0,7.9-6.4,14.3-14.3,14.3v3.6 c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6v-3.6c-7.9,0-14.3-6.4-14.3-14.3c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6 c0,3.9,3.2,7.1,7.1,7.1v-14.3c-7.9,0-14.3-6.4-14.3-14.3c0-7.9,6.4-14.3,14.3-14.3V75c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6v3.6 c7.9,0,14.3,6.4,14.3,14.3c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6c0-3.9-3.2-7.1-7.1-7.1V100C136.5,100,142.9,106.4,142.9,114.3z  M186.2,159.5c-9,11.4-25.2,12-28.4,12c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6c2.6,0,15.8-0.4,22.8-9.2c3.3-4.7,5.1-10.2,5-15.9 c0.1-2,1.8-3.5,3.7-3.4c0.9,0,1.8,0.5,2.5,1.2s1,1.6,0.9,2.6C192.7,146.7,190.4,153.7,186.2,159.5L186.2,159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    fill: "#E8EAF0",
    d: "M114.3,92.9c0,3.9,3.2,7.1,7.1,7.1V85.7C117.5,85.7,114.3,88.9,114.3,92.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    fill: "#E8EAF0",
    d: "M128.6,121.4c3.9,0,7.1-3.2,7.1-7.1c0-3.9-3.2-7.1-7.1-7.1V121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    fill: "#E8EAF0",
    d: "M46.4,149.2v36.5c0,2.9,7.8,7.1,19.6,7.1s19.6-4.3,19.6-7.1v-36.5 c-6.1,3.1-12.8,4.6-19.6,4.4C59.3,153.8,52.5,152.3,46.4,149.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_",
    fill: "#E8EAF0",
    cx: 66.1,
    cy: 139.3,
    rx: 19.6,
    ry: 7.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    fill: "#E8EAF0",
    d: "M170.4,25c0,5.9-6.4,10.6-14.3,10.7c-1.3,0-2.7-0.1-4-0.4c-0.2,0.2-0.4,0.4-0.7,0.6 c0.6,0.4,1.2,0.8,1.9,1.1c2.2,1.4,4.7,3.2,7.5,5.4c0.3,0.2,0.5,0.4,0.8,0.7c17.8,1.3,23.4,8.8,23.6,9c0.7,1,1.8,1.5,3,1.5 c0.7,0,1.4-0.2,2-0.6c1.6-1.1,2.1-3.3,1-4.9c-0.3-0.4-5.2-7.5-19.6-10.8c3.7-3,5.8-7.5,5.9-12.3c-0.5-7.9-6-14.6-13.7-16.7 c0,0.2,0,0.5-0.1,0.7c-0.3,2.2-0.7,4.3-1.2,6.5C166.9,16.8,170,20.5,170.4,25z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.9da8fce02e83503b638863d347e49a1a.svg";
export { ForwardRef as ReactComponent };